module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAPFBMVEUAAAD/alX/ZlL/ZFL/Z1P/ZVf/YlX/ZVT/ZFP/ZlT/ZVX/ZFT/ZVT/ZVT/ZFT/ZVT/ZVT/ZVT/ZVT/ZVR0CQRBAAAAE3RSTlMAGBkcJSYnSUqttbfk5ufv8fLzpGFT+gAAAI5JREFUOMvtlcsOwyAMBAklDyclgc7//2sP7QUXI7W5pBJ7QAuMBBbW4lzXp4IkDCUJJTseNHRMBSxs3jrUb0ixkPD2FT25mEOrILX7AzxHgDhrX4Xjq/iofRVuj9eE30Xt2lfhZQe4L9qff5SLwL03/rc3miEz8FDxtQ4We1tVfE3fBKMLki00y9i/pIqeqWQdp5eUehsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/user/disanf@2x.png
// module id = PMnO
// module chunks = 0